import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { WorkflowActions } from '../../model/Enum';
import {
  ApprovalsCol,
  AuthorContentNameCol,
  ContentAudienceCol,
  ContentActionCol,
  ContentIdCol,
  ContentTypeCol,
  DisapprovalsCol,
  DraftStateCol,
  DraftVersionCol,
  IsTestDataCol,
  LastPublicationDateCol,
  ProgressCol,
  PublicationStateCol,
  PublicationVersionCol,
  UpdatedDateCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentTable from './ContentTable';

class AuthoredContentTable extends ContentTable {
  protected tableHeader = constants.AUTHORED_CONTENT_TABLE_HEADER;
  protected tableId = WorkflowTableIdentity.AuthoredContent;
  protected columnDefinitions = [
    ContentIdCol,
    ContentAudienceCol,
    AuthorContentNameCol,
    ContentTypeCol,
    DraftStateCol,
    DraftVersionCol,
    PublicationStateCol,
    PublicationVersionCol,
    UpdatedDateCol,
    ApprovalsCol,
    DisapprovalsCol,
    LastPublicationDateCol,
    IsTestDataCol,
    ContentActionCol,
    ProgressCol,
  ];
  // @ts-expect-error TS2416 - strict migration
  protected allowedControlActions = [
    WorkflowActions.EDIT_RESOURCE_ACCESS,
    WorkflowActions.DEMOTE_AUDIENCE,
    WorkflowActions.RETRACT_REVIEW,
    WorkflowActions.ADD_PEER_REVIEWERS,
  ];
  // @ts-expect-error TS2416 - strict migration
  protected allowedFilterTypes = ['contentType', 'state'];
  protected selectionType = 'single';

  protected fetchWorkflows = async () => {
    const { userProfile } = this.props;
    const res = await this.mplServiceClient.getContentsForAuthor(userProfile.userId);
    return res.workflows;
  };

  protected validateUserRole = () => {
    return true;
  };
}

export default AuthoredContentTable;
